<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line clickable" *ngIf="!showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBack()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-normal" (click)="gotoInformationPage()">
        <i class="material-icons">contacts</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="refreshPage()">
        <i class="material-icons">refresh</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="updateShowSearch()">
        <i class="material-icons">search</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="openMenu()">
        <i class="material-icons">more_vert</i>
      </div>
    </div>
    <div class="ir-line-content" (click)="gotoEditPage()">
      <span
        >{{ inspection?.name }} <strong>({{ inspection?.sections?.length }})</strong></span
      >
    </div>
  </div>
  <div class="ir-line th-header-search" *ngIf="showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-unactive">
        <i class="material-icons">search</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="ir-line-content">
      <input
        autoFocus
        type="search"
        name="Search"
        placeholder="{{ 'common.placeholders.search' | translate }}"
        [(ngModel)]="query"
        focus="showSearch"
      />
    </div>
  </div>
</div>

<div class="ir-area ir-body th-body">
  <div class="th-loading" *ngIf="loading">
    <span>{{ 'common.loading' | translate }}...</span>
  </div>
  <div class="ir-section--list th-section--admin">
    <div class="ir-line ir-line-title">
      <div class="ir-line--right">
        <button
          class="ir-btn ir-btn--block ir-btn--title th-btn-action ir-txt--right"
          (click)="gotoCreateSectionPage()"
        >
          <span>{{ 'templates.add-section' | translate }}</span>
        </button>
      </div>
      <div class="ir-line-content">
        <span>{{ 'templates.sections' | translate }}</span>
      </div>
    </div>
    <inspection-model-detail
      [inspection]="inspection"
      (toggleOpenSection)="openSection($event)"
      (toggleSelectSection)="selectSection($event)"
      [query]="query"
    ></inspection-model-detail>
  </div>
</div>

<modal (modalOutput)="selectMenu($event)"></modal>

<input type="file" #fileInput style="display: none" (change)="upload($event)" multiple="true" />
<input type="file" #pricesInput style="display: none" (change)="upload($event)" multiple="true" />
<input
  type="file"
  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  #translationInput
  style="display: none"
  (change)="uploadTranslation($event)"
  multiple="true"
/>
<confirm
  #sectionsDeleteConfirm
  (confirmOutput)="deleteSections($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'sections.sure-to-delete-sections' | translate"
  [danger]="true"
></confirm>
<confirm
  #deleteConfirm
  (confirmOutput)="deleteInspection($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'templates.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<order-summaries
  #orderSections
  [title]="'templates.order-sections' | translate"
  (toggleSave)="saveSectionsOrder($event)"
  (toggleCancel)="close()"
></order-summaries>
<order-summaries
  #orderPlugins
  [title]="'templates.order-plugins' | translate"
  (toggleSave)="savePluginsOrder($event)"
  (toggleCancel)="close()"
></order-summaries>
